import { Box, Stack } from "@chakra-ui/react-v3";

import { Skeleton } from "./Skeleton";

export type ChartSkeletonProps = {
  /** Pixel height of the chart it stands in for; pass the chart's own `height`. */
  height: number;
  /** Reserve room for the legend below the plot, as the rendered chart does. */
  showLegend?: boolean;
};

/**
 * Placeholder for a chart that has not loaded yet, occupying exactly the
 * chart's height. ChartCanvas renders it while `loading`; other charts and
 * `Suspense` fallbacks around lazy charts can render it directly.
 *
 * Keep this module free of Recharts imports: it is the fallback shown while
 * a lazy chart chunk downloads, so importing Recharts here would load the
 * library before the fallback can render.
 */
export function ChartSkeleton(props: ChartSkeletonProps) {
  const { height, showLegend = false } = props;

  return (
    <Stack gap="2" width="full" height={`${height}px`}>
      {/* The plot takes whatever the legend leaves, so the total stays `height`. */}
      <Box flex="1" minH="0">
        <Skeleton height="full" width="full" borderRadius="md" />
      </Box>
      {showLegend && <Skeleton height="3" width="28" borderRadius="md" />}
    </Stack>
  );
}
